import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/view/layout/Layout"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/view/pages/Dashboard.vue"),
        meta: {
          title: 'LXP Digiskillhub - Dashboard',
          access_right: '1'
        }
      },
      {
        path: "/builder",
        name: "builder",
        component: () => import("@/view/pages/Builder.vue")
      },
      {
        path: "/join",
        component: () => import("@/view/pages/join/Join.vue"),
        redirect: "/join/register",
        children: [
          {
            name: "register",
            path: "register",
            component: () => import("@/view/pages/join/Register.vue"),
            meta: {
              title: 'LXP Digiskillhub'
            }
          },
          {
            name: "payment",
            path: "payment",
            component: () => import("@/view/pages/join/Payment.vue"),
            meta: {
              title: 'LXP Digiskillhub'
            }
          },
          {
            name: "success",
            path: "success",
            component: () => import("@/view/pages/join/Success.vue"),
            meta: {
              title: 'LXP Digiskillhub'
            }
          },
        ]
      },
      {
        path: "/classrooms",
        name: "classrooms",
        redirect: "/classrooms/list",
        component: () => import("@/view/pages/classroom/Classroom.vue"),
        meta: {
          title: 'LXP Digiskillhub - Classrooms',
          access_right: '2'
        },
        children: [
          {
            path: "/classrooms/list",
            name: "classroom-list",
            component: () => import("@/view/pages/classroom/Classrooms.vue"),
            meta: {
              title: 'LXP Digiskillhub - Classrooms',
              access_right: '1001'
            },
          },
          {
            path: "/classrooms/detail/:id",
            name: "classroom-detail",
            component: () => import("@/view/pages/classroom/ClassroomDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub - Detail Classrooms',
              access_right: '1001'
            },
          },
          {
            path: "/classrooms/add",
            name: "classroom-add",
            component: () => import("@/view/pages/classroom/ClassroomsAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub - Add Classroom',
              access_right: '1002'
            }
          },
          {
            path: "/classrooms/join",
            name: "join-class",
            component: () => import("@/view/pages/classroom/JoinClass.vue"),
            meta: {
              title: 'LXP Digiskillhub - Join Classroom',
              access_right: '1003'
            }
          },
          {
            path: "/classrooms/edit/:id",
            name: "classroom-edit",
            component: () => import("@/view/pages/classroom/ClassroomsUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub - Edit Classroom',
              access_right: '1002'
            }
          },
        ]
      },
      // {
      //   path: "/classroom/join",
      //   name: "join-class",
      //   component: () => import("@/view/pages/classroom/JoinClass.vue"),
      //   meta:{
      //     title: 'LXP Digiskillhub - Gabung Kelas'
      //   }
      // },
      {
        path: "/bank",
        name: "bank",
        component: () => import("@/view/pages/bank-materi-soal/BankMateriSoal.vue"),
        meta: {
          title: 'LXP Digiskillhub - Bank Materi dan Soal',
          access_right: '2012'
        }
      },
      {
        path: "/courses",
        name: "course",
        component: () => import("@/view/pages/courses/Course.vue"),
        meta: {
          title: 'LXP Digiskillhub - Course'
        }
      },
      {
        path: "/courses/add",
        name: "course-add",
        component: () => import("@/view/pages/courses/CourseAdd.vue"),
        meta: {
          title: 'LXP Digiskillhub - Course'
        }
      },
      {
        path: "/courses/edit/:id",
        name: "course-edit",
        component: () => import("@/view/pages/courses/CourseUpdate.vue"),
        meta: {
          title: 'LXP Digiskillhub - Course'
        }
      },
      {
        path: "/courses/detail/:id",
        name: "course-detail",
        component: () => import("@/view/pages/courses/CourseDetail.vue"),
        meta: {
          title: 'LXP Digiskillhub - Course'
        }
      },
      {
        path: "/courses/detail/:id/student",
        name: "course-detail",
        component: () => import("@/view/pages/courses/CourseDetailStudent.vue"),
        meta: {
          title: 'LXP Digiskillhub - Course'
        }
      },
      {
        path: "/agenda",
        name: "agenda",
        component: () => import("@/view/pages/Calendar.vue"),
        meta: {
          title: 'LXP Digiskillhub - Calendar'
        }
      },

      // Personal Storage
      {
        path: "/personal-storage",
        name: "personal-storage",
        component: () => import("@/view/pages/personal-storage/PersonalStorage.vue"),
        meta: {
          title: 'LXP Digiskillhub - File Personal',
          access_right: '3001'
        }
      },

      {
        path: "/presence",
        name: "presence",
        redirect: "/presence/list",
        component: () => import("@/view/pages/presence/Presence.vue"),
        meta: {
          title: 'LXP Digiskillhub | Kehadiran'
        },
        children: [
          {
            path: "/presence/list",
            name: "presence-list",
            component: () => import("@/view/pages/presence/PresenceList.vue"),
            meta: {
              title: 'LXP Digiskillhub | Kehadiran'
            },
          },
          {
            path: "/presence/edit/:id",
            name: "presence-edit",
            component: () => import("@/view/pages/presence/PresenceUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Kehadiran'
            },
          },
          {
            path: "/presence/detail/:id",
            name: "presence-detail",
            component: () => import("@/view/pages/presence/PresenceDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Kehadiran'
            },
          },
        ]
      },
      {
        path: "/school-report-card",
        name: "school-report-card",
        redirect: "/school-report-card/list",
        component: () => import("@/view/pages/report/school-report-card/SchoolReportCard.vue"),
        meta: {
          title: 'LXP Digiskillhub |Skill Performance'
        },
        children: [
          {
            path: "/school-report-card/list",
            name: "school-report-card-list",
            component: () => import("@/view/pages/report/school-report-card/SchoolReportCardList.vue"),
            meta: {
              title: 'LXP Digiskillhub |Skill Performance'
            },
          },
          {
            path: "/school-report-card/detail/assignment/:classwork_id/:classwork_type_id/:student_id",
            name: "school-report-card-detail-assignment",
            component: () => import("@/view/pages/report/school-report-card/SchoolReportCardAssignmentDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub |Skill Performance'
            },
          },
        ]
      },
      {
        path: "/message-box",
        name: "message-box",
        redirect: "/message-box/messages/:user_id/:message_to",
        component: () => import("@/view/pages/chats/Chat.vue"),
        meta: {
          title: 'LXP Digiskillhub | Kotak Pesan'
        },
        children: [
          // setting
          {
            path: "/message-box/messages/:user_id/:message_to",
            name: "message-box-message",
            component: () => import("@/view/pages/chats/Conversation.vue"),
            meta: {
              title: 'LXP Digiskillhub | Kotak Pesan',
              access_right: '5001'
            },
          },
        ]
      },
      {
        path: "/registrants",
        name: "registrants",
        redirect: "/registrants/list",
        component: () => import("@/view/pages/registrants/Registrant.vue"),
        meta: {
          title: 'LXP Digiskillhub | Pendaftar'
        },
        children: [
          {
            path: "list",
            name: "registrants-list",
            component: () => import("@/view/pages/registrants/List.vue"),
            meta: {
              title: 'LXP Digiskillhub | Pendaftar',
              access_right: '5001'
            },
          },
          {
            path: "pre",
            name: "registrants-pre",
            component: () => import("@/view/pages/registrants/Pre.vue"),
            meta: {
              title: 'LXP Digiskillhub | Pre Register',
              access_right: '5001'
            },
          },
          {
            path: "detail/:id",
            name: "registrants-detail",
            component: () => import("@/view/pages/registrants/Detail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Pendaftar',
              access_right: '5001'
            },
          },
        ]
      },
      {
        path: "/billings",
        name: "billings",
        redirect: "/billings/list",
        component: () => import("@/view/pages/billings/Billing.vue"),
        meta: {
          title: 'LXP Digiskillhub | Billing'
        },
        children: [
          {
            path: "list",
            name: "billings-list",
            component: () => import("@/view/pages/billings/List.vue"),
            meta: {
              title: 'LXP Digiskillhub | Billing',
              access_right: '5001'
            },
          },
          {
            path: "detail/:id",
            name: "billings-detail",
            component: () => import("@/view/pages/billings/Detail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Billing',
              access_right: '5001'
            },
          },
          {
            path: "checkout/:id/:course_id",
            name: "billings-checkout",
            component: () => import("@/view/pages/billings/Checkout.vue"),
            meta: {
              title: 'LXP Digiskillhub | Billing',
              access_right: '5001'
            },
          },
          {
            path: "payment/:id/:course_id",
            name: "billings-checkout",
            component: () => import("@/view/pages/billings/Payment.vue"),
            meta: {
              title: 'LXP Digiskillhub | Billing',
              access_right: '5001'
            },
          },
        ]
      },
      {
        path: "/academic-calendars",
        name: "academic-calendars",
        redirect: "/academic-calendars/list",
        component: () => import("@/view/pages/chats/Chat.vue"),
        meta: {
          title: 'LXP Digiskillhub | Kalender Akademi'
        },
        children: [
          {
            path: "/academic-calendars/list",
            name: "academic-calendars-list",
            component: () => import("@/view/pages/academic-calendars/List.vue"),
            meta: {
              title: 'LXP Digiskillhub | Kalender Akademi',
              access_right: '8007'
            },
          },
          {
            path: "/academic-calendars/add",
            name: "academic-calendars-add",
            component: () => import("@/view/pages/academic-calendars/AcademicCalendarAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Kalender Akademi',
              access_right: '8008'
            },
          },
          {
            path: "/academic-calendars/add-holidays",
            name: "academic-calendars-add-holidays",
            component: () => import("@/view/pages/academic-calendars/AcademicCalendarAddHoliday.vue"),
            meta: {
              title: 'LXP Digiskillhub | Kalender Akademi',
              access_right: '8008'
            },
          },
          {
            path: "/academic-calendars/edit/:id",
            name: "academic-calendars-edit",
            component: () => import("@/view/pages/academic-calendars/AcademicCalendarUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Kalender Akademi',
              access_right: '8008'
            },
          },
        ]
      },
      {
        path: "/academic-calendars-year",
        name: "academic-calendars-year",
        redirect: "/academic-calendars-year/list",
        component: () => import("@/view/pages/chats/Chat.vue"),
        meta: {
          title: 'LXP Digiskillhub | Kalender Akademik'
        },
        children: [
          {
            path: "/academic-calendars-year/list",
            name: "academic-calendars-year-list",
            component: () => import("@/view/pages/academic-calendars/AcademicCalendarYear.vue"),
            meta: {
              title: 'LXP Digiskillhub | Kalender Akademik',
              access_right: '8007'
            },
          },
        ]
      },
      // access-roles
      {
        path: "/user-managements/role-access",
        name: "master-access-roles",
        component: () => import("@/view/pages/masters/user-managements/RoleAccess.vue"),
        meta: {
          title: 'LXP Digiskillhub | Master - Hak Akses Peran',
          access_right: '9031'
        },
      },

      // access-users
      {
        path: "/user-managements/user-access",
        name: "master-access-users",
        component: () => import("@/view/pages/masters/user-managements/UserAccess.vue"),
        meta: {
          title: 'LXP Digiskillhub | Master - Hak Akses Pengguna',
          access_right: '9033'
        },
      },

      // ::masters::
      {
        path: "/masters",
        name: "masters",
        redirect: "/masters/settings",
        component: () => import("@/view/pages/masters/Masters.vue"),
        meta: {
          title: 'LXP Digiskillhub | Master - Setting'
        },
        children: [
          // setting
          {
            path: "/masters/settings",
            name: "master-setting",
            component: () => import("@/view/pages/masters/Setting.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Setting'
            },
          },
          // schools
          {
            path: "/masters/schools",
            name: "master-schools",
            component: () => import("@/view/pages/masters/schools/Schools.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Sekolah'
            },
          },
          {
            path: "/masters/schools/add",
            name: "master-schools-add",
            component: () => import("@/view/pages/masters/schools/SchoolsAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Sekolah'
            },
          },
          {
            path: "/masters/schools/edit/:id",
            name: "master-schools-edit",
            component: () => import("@/view/pages/masters/schools/SchoolsUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Sekolah'
            },
          },
          {
            path: "/masters/schools/detail/:id",
            name: "master-schools-detail",
            component: () => import("@/view/pages/masters/schools/SchoolsDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Sekolah'
            },
          },
          {
            path: "/masters/schools/delete/:id",
            name: "master-schools-delete",
            component: () => import("@/view/pages/masters/schools/DeleteSchools.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Sekolah'
            },
          },

          // roles
          {
            path: "/masters/roles",
            name: "master-roles",
            component: () => import("@/view/pages/masters/roles/Roles.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Role',
              access_right: '9027'
            },
          },
          {
            path: "/masters/roles/add",
            name: "master-roles-add",
            component: () => import("@/view/pages/masters/roles/RolesAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Role',
              access_right: '9028'
            },
          },
          {
            path: "/masters/roles/edit/:id",
            name: "master-roles-edit",
            component: () => import("@/view/pages/masters/roles/RolesUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Peran',
              access_right: '9028'
            },
          },
          {
            path: "/masters/roles/detail/:id",
            name: "master-roles-detail",
            component: () => import("@/view/pages/masters/roles/RolesDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Peran',
              access_right: '9027'
            },
          },
          {
            path: "/masters/roles/delete/:id",
            name: "master-roles-delete",
            component: () => import("@/view/pages/masters/roles/RolesDelete.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Peran',
              access_right: '9028'
            },
          },

          // users
          {
            path: "/masters/users",
            name: "master-users",
            component: () => import("@/view/pages/masters/users/Users.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Pengguna',
              access_right: '9001'
            },
          },
          // teachers
          {
            path: "/masters/users/teachers",
            name: "master-users-teachers-",
            component: () => import("@/view/pages/masters/users/Teachers.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Mentor',
              access_right: '8001'
            },
          },
          {
            path: "/masters/users/teachers/add",
            name: "master-users-teachers-add",
            component: () => import("@/view/pages/masters/users/TeachersAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Mentor',
              access_right: '8002'
            },
          },
          {
            path: "/masters/users/teachers/edit/:id",
            name: "master-users-teachers-edit",
            component: () => import("@/view/pages/masters/users/TeachersUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Mentor',
              access_right: '8002'
            },
          },
          {
            path: "/masters/users/teachers/detail/:id",
            name: "master-users-teachers-detail",
            component: () => import("@/view/pages/masters/users/TeachersDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Mentor',
              access_right: '8001'
            },
          },
          // students
          {
            path: "/masters/users/students",
            name: "master-users-students-",
            component: () => import("@/view/pages/masters/users/Students.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Talenta',
              access_right: '8001'
            },
          },
          {
            path: "/masters/users/students/add",
            name: "master-users-students-add",
            component: () => import("@/view/pages/masters/users/StudentsAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Talenta',
              access_right: '8002'
            },
          },
          {
            path: "/masters/users/import",
            name: "master-users-import",
            component: () => import("@/view/pages/masters/users/Import.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Pengguna',
              access_right: '8002'
            },
          },
          {
            path: "/masters/users/students/edit/:id",
            name: "master-users-students-edit",
            component: () => import("@/view/pages/masters/users/StudentsUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Talenta',
              access_right: '8002'
            },
          },
          {
            path: "/masters/users/students/detail/:id",
            name: "master-users-students-detail",
            component: () => import("@/view/pages/masters/users/StudentsDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Talenta',
              access_right: '8001'
            },
          },
          {
            path: "/masters/users/add",
            name: "master-users-add",
            component: () => import("@/view/pages/masters/users/UsersAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Pengguna',
              access_right: '9002'
            },
          },
          {
            path: "/masters/users/detail/:id",
            name: "master-users-detail",
            component: () => import("@/view/pages/masters/users/UsersDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Pengguna',
              access_right: '9001'
            },
          },
          {
            path: "/masters/users/edit/:id",
            name: "master-users-edit",
            component: () => import("@/view/pages/masters/users/UsersUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Pengguna',
              access_right: '9002'
            },
          },
          {
            path: "/masters/users/delete/:id",
            name: "master-users-delete",
            component: () => import("@/view/pages/masters/users/UsersDelete.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Pengguna',
              access_right: '9002'
            },
          },

          // collections
          {
            path: "/masters/collections",
            name: "master-collections",
            component: () => import("@/view/pages/masters/collections/Collections.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Collection',
              access_right: '9003'
            },
          },
          {
            path: "/masters/collections/add",
            name: "master-collections-add",
            component: () => import("@/view/pages/masters/collections/CollectionsAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Collection',
              access_right: '9004'
            },
          },
          {
            path: "/masters/collections/edit/:id",
            name: "master-collections-edit",
            component: () => import("@/view/pages/masters/collections/CollectionsUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Collection',
              access_right: '9004'
            },
          },
          {
            path: "/masters/collections/detail/:id",
            name: "master-collections-detail",
            component: () => import("@/view/pages/masters/collections/CollectionsDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Collection',
              access_right: '9003'
            },
          },

          // formats
          {
            path: "/masters/formats",
            name: "master-formats",
            component: () => import("@/view/pages/masters/formats/Formats.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Format',
              access_right: '9005'
            },
          },
          {
            path: "/masters/formats/add",
            name: "master-formats-add",
            component: () => import("@/view/pages/masters/formats/FormatsAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Format',
              access_right: '9006'
            },
          },
          {
            path: "/masters/formats/detail/:id",
            name: "master-formats-detail",
            component: () => import("@/view/pages/masters/formats/FormatsDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Format',
              access_right: '9005'
            },
          },
          {
            path: "/masters/formats/edit/:id",
            name: "master-formats-edit",
            component: () => import("@/view/pages/masters/formats/FormatsUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Format',
              access_right: '9006'
            },
          },
          {
            path: "/masters/formats/delete/:id",
            name: "master-formats-delete",
            component: () => import("@/view/pages/masters/formats/FormatsDelete.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Format',
              access_right: '9006'
            },
          },

          // categories
          {
            path: "/masters/categories",
            name: "master-categories",
            component: () => import("@/view/pages/masters/categories/Categories.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kategori',
              access_right: '9007'
            },
          },
          {
            path: "/masters/categories/add",
            name: "master-categories-add",
            component: () => import("@/view/pages/masters/categories/CategoriesAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kategori',
              access_right: '9008'
            },
          },
          {
            path: "/masters/categories/edit/:id",
            name: "master-categories-edit",
            component: () => import("@/view/pages/masters/categories/CategoriesUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kategori',
              access_right: '9008'
            },
          },
          {
            path: "/masters/categories/delete/:id",
            name: "master-categories-delete",
            component: () => import("@/view/pages/masters/categories/CategoriesDelete.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kategori',
              access_right: '9008'
            },
          },
          {
            path: "/masters/categories/detail/:id",
            name: "master-categories-detail",
            component: () => import("@/view/pages/masters/categories/CategoriesDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kategori',
              access_right: '9007'
            },
          },

          // classworks-types
          {
            path: "/masters/classwork-types",
            name: "master-classwork-types",
            component: () => import("@/view/pages/masters/classwork_types/NewClassworkTypes.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Tugas',
              access_right: '9019'
            },
          },
          {
            path: "/masters/classwork-types/detail/:id",
            name: "master-classwork-types-detail",
            component: () => import("@/view/pages/masters/classwork_types/NewClassworkTypesDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Tugas',
              access_right: '9019'
            },
          },

          // duration-units
          {
            path: "/masters/duration-units",
            name: "master-duration-types",
            component: () => import("@/view/pages/masters/duration_units/NewDurationUnits.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Satuan Durasi',
              access_right: '9023'
            },
          },
          {
            path: "/masters/duration-units/add",
            name: "master-duration-types-add",
            component: () => import("@/view/pages/masters/duration_units/NewDurationUnitsAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Satuan Durasi',
              access_right: '9024'
            },
          },
          {
            path: "/masters/duration-units/edit/:id",
            name: "master-duration-types-edit",
            component: () => import("@/view/pages/masters/duration_units/NewDurationUnitsUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Satuan Durasi',
              access_right: '9024'
            },
          },
          {
            path: "/masters/duration-units/detail/:id",
            name: "master-duration-types-detail",
            component: () => import("@/view/pages/masters/duration_units/NewDurationUnitsDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Satuan Durasi',
              access_right: '9023'
            },
          },

          // content-types
          {
            path: "/masters/content-types",
            name: "master-content-types",
            component: () => import("@/view/pages/masters/content_types/NewContentTypes.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Konten',
              access_right: '9021'
            },
          },
          {
            path: "/masters/content-types/add",
            name: "master-content-types-add",
            component: () => import("@/view/pages/masters/content_types/NewContentTypesAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Konten',
              access_right: '9022'
            },
          },
          {
            path: "/masters/content-types/edit/:id",
            name: "master-content-types-edit",
            component: () => import("@/view/pages/masters/content_types/NewContentTypesUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Konten',
              access_right: '9022'
            },
          },
          {
            path: "/masters/content-types/detail/:id",
            name: "master-content-types-detail",
            component: () => import("@/view/pages/masters/content_types/NewContentTypesDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Konten',
              access_right: '9021'
            },
          },

          // presence-types
          {
            path: "/masters/presence-types",
            name: "master-presence-types",
            component: () => import("@/view/pages/masters/presence_types/NewPresenceTypes.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Absen',
              access_right: '9009'
            },
          },
          {
            path: "/masters/presence-types/add",
            name: "master-presence-types-add",
            component: () => import("@/view/pages/masters/presence_types/PresenceTypesAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Absen',
              access_right: '9010'
            },
          },
          {
            path: "/masters/presence-types/detail/:id",
            name: "master-presence-types-detail",
            component: () => import("@/view/pages/masters/presence_types/PresenceTypesDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Absen',
              access_right: '9009'
            },
          },
          {
            path: "/masters/presence-types/edit/:id",
            name: "master-presence-types-edit",
            component: () => import("@/view/pages/masters/presence_types/PresenceTypesUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Absen',
              access_right: '9010'
            },
          },

          // meeting platform
          // {
          //   path: "/masters/meeting-platforms",
          //   name: "master-presence-platforms",
          //   component: () => import("@/view/pages/masters/meeting-platforms/MeetingPlatforms.vue"),
          //   meta:{
          //     title: 'LXP Digiskillhub | Master - Platform Pertemuan'
          //   },
          // },
          {
            path: "/masters/meeting-platforms",
            name: "master-presence-platforms",
            component: () => import("@/view/pages/masters/meeting-platforms/NewMeetingPlatforms.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Platform Pertemuan',
              access_right: '9011'
            },
          },
          {
            path: "/masters/meeting-platforms/add",
            name: "master-presence-platforms-add",
            component: () => import("@/view/pages/masters/meeting-platforms/NewMeetingPlatformsAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Platform Pertemuan',
              access_right: '9012'
            },
          },
          {
            path: "/masters/meeting-platforms/edit/:id",
            name: "master-presence-platforms-edit",
            component: () => import("@/view/pages/masters/meeting-platforms/NewMeetingPlatformsUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Platform Pertemuan',
              access_right: '9012'
            },
          },
          {
            path: "/masters/meeting-platforms/detail/:id",
            name: "master-presence-platforms-detail",
            component: () => import("@/view/pages/masters/meeting-platforms/NewMeetingPlatformsDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Platform Pertemuan',
              access_right: '9011'
            },
          },

          // section
          {
            path: "/masters/sections",
            name: "master-seksi",
            component: () => import("@/view/pages/masters/sections/Sections.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Sesi'
            },
          },

          // question-types
          {
            path: "/masters/question-types",
            name: "master-question-types",
            component: () => import("@/view/pages/masters/question-types/NewQuestionTypes.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Pertanyaan',
              access_right: '9025'
            },
          },
          {
            path: "/masters/question-types/add",
            name: "master-question-types-add",
            component: () => import("@/view/pages/masters/question-types/NewQuestionTypesAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Pertanyaan',
              access_right: '9026'
            },
          },
          {
            path: "/masters/question-types/edit/:id",
            name: "master-question-types-edit",
            component: () => import("@/view/pages/masters/question-types/NewQuestionTypesUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Pertanyaan',
              access_right: '9026'
            },
          },
          {
            path: "/masters/question-types/detail/:id",
            name: "master-question-types-detail",
            component: () => import("@/view/pages/masters/question-types/NewQuestionTypesDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Pertanyaan',
              access_right: '9025'
            },
          },

          // topics
          // {
          //   path: "/masters/topics",
          //   name: "master-topics",
          //   component: () => import("@/view/pages/masters/topics/NewTopics.vue"),
          //   meta:{
          //     title: 'LXP Digiskillhub | Master - Topik'
          //   },
          // },
          // {
          //   path: "/masters/topics/add",
          //   name: "master-topics-add",
          //   component: () => import("@/view/pages/masters/topics/TopicsAdd.vue"),
          //   meta:{
          //     title: 'LXP Digiskillhub | Master - Topik'
          //   },
          // },
          // {
          //   path: "/masters/topics/update/:id",
          //   name: "master-topics-update",
          //   component: () => import("@/view/pages/masters/topics/TopicsUpdate.vue"),
          //   meta:{
          //     title: 'LXP Digiskillhub | Master - Topik'
          //   },
          // },
          // {
          //   path: "/masters/topics/detail/:id",
          //   name: "master-topics-detail",
          //   component: () => import("@/view/pages/masters/topics/TopicsDetail.vue"),
          //   meta:{
          //     title: 'LXP Digiskillhub | Master - Topik'
          //   },
          // },

          // competence-types
          {
            path: "/masters/competence-types",
            name: "master-competence-types",
            component: () => import("@/view/pages/masters/competence-types/CompetenceType.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Kompetensi'
            },
          },
          {
            path: "/masters/competence-types/add",
            name: "master-competence-types-add",
            component: () => import("@/view/pages/masters/competence-types/CompetenceTypeAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Kompetensi'
            },
          },
          {
            path: "/masters/competence-types/edit/:id",
            name: "master-competence-types-edit",
            component: () => import("@/view/pages/masters/competence-types/CompetenceTypeUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Kompetensi'
            },
          },
          {
            path: "/masters/competence-types/detail/:id",
            name: "master-competence-types-detail",
            component: () => import("@/view/pages/masters/competence-types/CompetenceTypeDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Kompetensi'
            },
          },

          // competence-standards
          {
            path: "/masters/competence-standards",
            name: "master-competence-standards",
            component: () => import("@/view/pages/masters/competence-standards/CompetenceStandard.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Standar Kompetensi',
              access_right: '8005'
            },
          },
          {
            path: "/masters/competence-standards/add",
            name: "master-competence-standards-add",
            component: () => import("@/view/pages/masters/competence-standards/CompetenceStandardAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Standar Kompetensi',
              access_right: '8006'
            },
          },
          {
            path: "/masters/competence-standards/edit/:id",
            name: "master-competence-standards-edit",
            component: () => import("@/view/pages/masters/competence-standards/CompetenceStandardUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Standar Kompetensi',
              access_right: '8006'
            },
          },
          {
            path: "/masters/competence-standards/detail/:id",
            name: "master-competence-standards-detail",
            component: () => import("@/view/pages/masters/competence-standards/CompetenceStandardDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Standar Kompetensi',
              access_right: '8005'
            },
          },

          // majors
          {
            path: "/masters/majors",
            name: "master-majors",
            component: () => import("@/view/pages/masters/majors/Majors.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jurusan',
              access_right: '8015'
            },
          },
          {
            path: "/masters/majors/add",
            name: "master-majors-add",
            component: () => import("@/view/pages/masters/majors/MajorsAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jurusan',
              access_right: '8016'
            },
          },
          {
            path: "/masters/majors/edit/:id",
            name: "master-majors-edit",
            component: () => import("@/view/pages/masters/majors/MajorsUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jurusan',
              access_right: '8016'
            },
          },
          {
            path: "/masters/majors/detail/:id",
            name: "master-majors-detail",
            component: () => import("@/view/pages/masters/majors/MajorsDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jurusan',
              access_right: '8015'
            },
          },
          // school-years
          {
            path: "/masters/school-years",
            name: "master-school-years",
            component: () => import("@/view/pages/masters/school-years/SchoolYears.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Tahun Ajaran',
              access_right: '8013'
            },
          },
          {
            path: "/masters/school-years/add",
            name: "master-school-years-add",
            component: () => import("@/view/pages/masters/school-years/SchoolYearsAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Tahun Ajaran',
              access_right: '8014'
            },
          },
          {
            path: "/masters/school-years/edit/:id",
            name: "master-school-years-edit",
            component: () => import("@/view/pages/masters/school-years/SchoolYearsUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Tahun Ajaran',
              access_right: '8014'
            },
          },
          {
            path: "/masters/school-years/detail/:id",
            name: "master-school-years-detail",
            component: () => import("@/view/pages/masters/school-years/SchoolYearsDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Tahun Ajaran',
              access_right: '8013'
            },
          },
          // classroom-categories
          {
            path: "/masters/classroom-categories",
            name: "master-classroom-categories",
            component: () => import("@/view/pages/masters/classroom-categories/List.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kategori Kelas',
              access_right: '9013'
            },
          },
          {
            path: "/masters/classroom-categories/add",
            name: "master-classroom-categories-add",
            component: () => import("@/view/pages/masters/classroom-categories/Add.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kategori Kelas',
              access_right: '9014'
            },
          },
          {
            path: "/masters/classroom-categories/edit/:id",
            name: "master-classroom-categories-edit",
            component: () => import("@/view/pages/masters/classroom-categories/Update.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kategori Kelas',
              access_right: '9014'
            },
          },
          {
            path: "/masters/classroom-categories/detail/:id",
            name: "master-classroom-categories-detail",
            component: () => import("@/view/pages/masters/classroom-categories/Detail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kategori Kelas',
              access_right: '9013'
            },
          },
          // programs
          {
            path: "/masters/programs",
            name: "master-programs",
            component: () => import("@/view/pages/masters/programs/List.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Program',
              access_right: '9013'
            },
          },
          {
            path: "/masters/programs/add",
            name: "master-programs-add",
            component: () => import("@/view/pages/masters/programs/Add.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Program',
              access_right: '9014'
            },
          },
          {
            path: "/masters/programs/edit/:id",
            name: "master-programs-edit",
            component: () => import("@/view/pages/masters/programs/Update.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Program',
              access_right: '9014'
            },
          },
          {
            path: "/masters/programs/detail/:id",
            name: "master-programs-detail",
            component: () => import("@/view/pages/masters/programs/Detail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Program',
              access_right: '9013'
            },
          },
          // promos
          {
            path: "/masters/promos",
            name: "master-promos",
            component: () => import("@/view/pages/masters/promos/List.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Promo',
              access_right: '9013'
            },
          },
          {
            path: "/masters/promos/add",
            name: "master-promos-add",
            component: () => import("@/view/pages/masters/promos/Add.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Promo',
              access_right: '9014'
            },
          },
          {
            path: "/masters/promos/edit/:id",
            name: "master-promos-edit",
            component: () => import("@/view/pages/masters/promos/Update.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Promo',
              access_right: '9014'
            },
          },
          {
            path: "/masters/promos/detail/:id",
            name: "master-promos-detail",
            component: () => import("@/view/pages/masters/promos/Detail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Promo',
              access_right: '9013'
            },
          },
          // announcement-categories
          {
            path: "/masters/announcement-categories",
            name: "master-announcement-categories",
            component: () => import("@/view/pages/masters/announcement-categories/AnnouncementCategory.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kategori Pengumuman',
              access_right: '9013'
            },
          },
          {
            path: "/masters/announcement-categories/add",
            name: "master-announcement-categories-add",
            component: () => import("@/view/pages/masters/announcement-categories/AnnouncementCategoryAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kategori Pengumuman',
              access_right: '9014'
            },
          },
          {
            path: "/masters/announcement-categories/edit/:id",
            name: "master-announcement-categories-edit",
            component: () => import("@/view/pages/masters/announcement-categories/AnnouncementCategoryUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kategori Pengumuman',
              access_right: '9014'
            },
          },
          {
            path: "/masters/announcement-categories/detail/:id",
            name: "master-announcement-categories-detail",
            component: () => import("@/view/pages/masters/announcement-categories/AnnouncementCategoryDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kategori Pengumuman',
              access_right: '9013'
            },
          },
          // announcements
          {
            path: "/masters/announcements",
            name: "master-announcements",
            component: () => import("@/view/pages/masters/announcements/Announcement.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Pengumuman',
              access_right: '8009'
            },
          },
          {
            path: "/masters/announcements/add",
            name: "master-announcements-add",
            component: () => import("@/view/pages/masters/announcements/AnnouncementAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Pengumuman',
              access_right: '8010'
            },
          },
          {
            path: "/masters/announcements/edit/:id",
            name: "master-announcements-edit",
            component: () => import("@/view/pages/masters/announcements/AnnouncementUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Pengumuman',
              access_right: '8010'
            },
          },
          {
            path: "/masters/announcements/detail/:id",
            name: "master-announcements-detail",
            component: () => import("@/view/pages/masters/announcements/AnnouncementDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Pengumuman',
              access_right: '8009'
            },
          },
          // periode-types
          {
            path: "/masters/periode-types",
            name: "master-periode-types",
            component: () => import("@/view/pages/masters/periode-types/PeriodeType.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Periode',
              access_right: '9015'
            },
          },
          {
            path: "/masters/periode-types/add",
            name: "master-periode-types-add",
            component: () => import("@/view/pages/masters/periode-types/PeriodeTypeAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Periode',
              access_right: '9016'
            },
          },
          {
            path: "/masters/periode-types/edit/:id",
            name: "master-periode-types-edit",
            component: () => import("@/view/pages/masters/periode-types/PeriodeTypeUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Periode',
              access_right: '9016'
            },
          },
          {
            path: "/masters/periode-types/detail/:id",
            name: "master-periode-types-detail",
            component: () => import("@/view/pages/masters/periode-types/PeriodeTypeDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Jenis Periode',
              access_right: '9015'
            },
          },
          // minimum-completeness-criterias
          {
            path: "/masters/minimum-completeness-criterias",
            name: "master-minimum-completeness-criterias",
            component: () => import("@/view/pages/masters/minimum-completeness-criterias/MinimumCompletenessCriteria.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kriteria Ketuntasan Minimal(KKM)',
              access_right: '8011'
            },
          },
          // {
          //   path: "/masters/minimum-completeness-criterias/add",
          //   name: "master-minimum-completeness-criterias-add",
          //   component: () => import("@/view/pages/masters/minimum-completeness-criterias/MinimumCompletenessCriteriaAdd.vue"),
          //   meta:{
          //     title: 'LXP Digiskillhub | Master - Kriteria Ketuntasan Minimal(KKM)'
          //   },
          // },
          // {
          //   path: "/masters/minimum-completeness-criterias/edit/:id",
          //   name: "master-minimum-completeness-criterias-edit",
          //   component: () => import("@/view/pages/masters/minimum-completeness-criterias/MinimumCompletenessCriteriaUpdate.vue"),
          //   meta:{
          //     title: 'LXP Digiskillhub | Master - Kriteria Ketuntasan Minimal(KKM)'
          //   },
          // },
          // {
          //   path: "/masters/minimum-completeness-criterias/detail/:id",
          //   name: "master-minimum-completeness-criterias-detail",
          //   component: () => import("@/view/pages/masters/minimum-completeness-criterias/MinimumCompletenessCriteriaDetail.vue"),
          //   meta:{
          //     title: 'LXP Digiskillhub | Master - Kriteria Ketuntasan Minimal(KKM)'
          //   },
          // },

          // class-groups
          {
            path: "/masters/class-groups",
            name: "master-class-groups",
            component: () => import("@/view/pages/masters/class-groups/ClassGroups.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kelompok Kelas',
              access_right: '8003'
            },
          },
          {
            path: "/masters/class-groups/add",
            name: "master-class-groups-add",
            component: () => import("@/view/pages/masters/class-groups/ClassGroupsAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kelompok Kelas',
              access_right: '8004'
            },
          },
          {
            path: "/masters/class-groups/edit/:id",
            name: "master-class-groups-edit",
            component: () => import("@/view/pages/masters/class-groups/ClassGroupsUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kelompok Kelas',
              access_right: '8004'
            },
          },
          {
            path: "/masters/class-groups/detail/:classGroupid/:teacherId",
            name: "master-class-groups-detail",
            component: () => import("@/view/pages/masters/class-groups/ClassGroupsDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kelompok Kelas',
              access_right: '8003'
            },
          },
          {
            path: "/masters/class-groups/sub-detail/:classGroupid/:teacherId",
            name: "master-class-groups-detail",
            component: () => import("@/view/pages/masters/class-groups/Detail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Kelompok Kelas',
              access_right: '8003'
            },
          },

          // grade
          {
            path: "/masters/grades",
            name: "master-grades",
            component: () => import("@/view/pages/masters/grades/Grades.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Tingkat',
              access_right: '8017'
            },
          },
          {
            path: "/masters/grades/add",
            name: "master-grades-add",
            component: () => import("@/view/pages/masters/grades/GradesAdd.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Tingkat',
              access_right: '8018'
            },
          },
          {
            path: "/masters/grades/edit/:id",
            name: "master-grades-edit",
            component: () => import("@/view/pages/masters/grades/GradesUpdate.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Tingkat',
              access_right: '8018'
            },
          },
          {
            path: "/masters/grades/delete/:id",
            name: "master-grades-delete",
            component: () => import("@/view/pages/masters/grades/GradesDelete.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Tingkat',
              access_right: '8018'
            },
          },
          {
            path: "/masters/grades/detail/:id",
            name: "master-grades-detail",
            component: () => import("@/view/pages/masters/grades/GradesDetail.vue"),
            meta: {
              title: 'LXP Digiskillhub | Master - Tingkat',
              access_right: '8017'
            },
          },
        ]
      },


      // help
      {
        path: "/help",
        name: "help",
        component: () => import("@/view/pages/Help.vue"),
        meta: {
          title: 'LXP Digiskillhub | Help'
        }
      },
      // blankboard
      {
        path: "/blankboard",
        name: "blankboard",
        component: () => import("@/view/pages/Blankboard.vue"),
        meta: {
          title: 'Blankboard'
        }
      },
      // profile
      {
        path: "/profile",
        name: "profile",
        component: () => import("@/view/pages/custom_pages/Profile.vue"),
        meta: {
          title: 'LXP Digiskillhub | Profil'
        }
      },
    ]
  },
  {
    path: "/",
    component: () => import("@/view/pages/auth/Parent.vue"),
    redirect: "/login",
    children: [
      {
        name: "login",
        path: "/login",
        component: () => import("@/view/pages/auth/LoginPage.vue"),
        meta: {
          title: 'LXP Digiskillhub'
        }
      },
      {
        name: "forgot-password",
        path: "/forgot-password",
        component: () => import("@/view/pages/auth/ForgotPasswordPage.vue"),
        meta: {
          title: 'LXP Digiskillhub - Lupa Password'
        }
      },
      {
        name: "reset-password",
        path: "/reset-password",
        component: () => import("@/view/pages/auth/ResetPasswordPage.vue"),
        meta: {
          title: 'LXP Digiskillhub - Reset Password'
        }
      }
    ]
  },
  {
    path: "/class",
    component: () => import("@/view/pages/class/Class.vue"),
    redirect: "/class/form",
    children: [
      {
        name: "form",
        path: "form",
        component: () => import("@/view/pages/class/Form.vue"),
        meta: {
          title: 'LXP Digiskillhub'
        }
      },
      {
        name: "register",
        path: "register",
        component: () => import("@/view/pages/class/Register.vue"),
        meta: {
          title: 'LXP Digiskillhub'
        }
      },
      {
        name: "pre-register",
        path: "pre-register",
        component: () => import("@/view/pages/class/PreRegister.vue"),
        meta: {
          title: 'LXP Digiskillhub'
        }
      },
      {
        name: "checkout",
        path: "checkout",
        component: () => import("@/view/pages/class/Checkout.vue"),
        meta: {
          title: 'LXP Digiskillhub'
        }
      },
      {
        name: "payment",
        path: "payment",
        component: () => import("@/view/pages/class/Payment.vue"),
        meta: {
          title: 'LXP Digiskillhub'
        }
      },
      {
        name: "success",
        path: "success",
        component: () => import("@/view/pages/class/Success.vue"),
        meta: {
          title: 'LXP Digiskillhub'
        }
      },
      {
        name: "success-wait",
        path: "success-wait",
        component: () => import("@/view/pages/class/SuccessWait.vue"),
        meta: {
          title: 'LXP Digiskillhub'
        }
      },
    ]
  },
  {
    path: "/class-blank",
    component: () => import("@/view/pages/class-blank/Class.vue"),
    redirect: "/class/form",
    children: [
      {
        name: "form",
        path: "form",
        component: () => import("@/view/pages/class/Form.vue"),
        meta: {
          title: 'LXP Digiskillhub'
        }
      },
      {
        name: "register",
        path: "register",
        component: () => import("@/view/pages/class-blank/Register.vue"),
        meta: {
          title: 'LXP Digiskillhub'
        }
      },
      {
        name: "pre-register",
        path: "pre-register",
        component: () => import("@/view/pages/class/PreRegister.vue"),
        meta: {
          title: 'LXP Digiskillhub'
        }
      },
      {
        name: "checkout",
        path: "checkout",
        component: () => import("@/view/pages/class/Checkout.vue"),
        meta: {
          title: 'LXP Digiskillhub'
        }
      },
      {
        name: "payment",
        path: "payment",
        component: () => import("@/view/pages/class/Payment.vue"),
        meta: {
          title: 'LXP Digiskillhub'
        }
      },
      {
        name: "success",
        path: "success",
        component: () => import("@/view/pages/class/Success.vue"),
        meta: {
          title: 'LXP Digiskillhub'
        }
      },
    ]
  },
  {
    name: "change-password",
    path: "/change-password",
    component: () => import("@/view/pages/custom_pages/profile-comp/RemakePassword.vue"),
    meta: {
      title: 'LXP Digiskillhub'
    }
  },
  // redirect to 404
  {
    path: "*",
    redirect: "/404"
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    meta: {
      title: 'LXP Digiskillhub | Page Not Found'
    },
    component: () => import("@/view/pages/error/Error-1.vue")
  },

  // 503
  {
    path: '/access-forbidden',
    name: 'access-forbidden',
    meta: {
      title: 'LXP Digiskillhub | Access Forbidden'
    },
    component: () => import('@/view/pages/error/Error-7.vue')
  },
]

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

// Route Middleware
router.beforeEach((to, from, next) => {
  // if (to.matched.some(record => record.meta.access_right)) {
  //   let localStorageAccessRight = JSON.parse(localStorage.getItem('access_right_display'))
  //   // //('localStorageAccessRight', localStorageAccessRight)
  //   if (localStorageAccessRight != null) {
  //     let result = false
  //     for (let i = 0; i < localStorageAccessRight.length; i++) {
  //       result = false
  //       if (localStorageAccessRight[i] == to.meta.access_right) {
  //         result = true
  //         break
  //       }
  //     }
  //     if (result) {
  //       next()
  //     } else {
  //       next('/access-forbidden')
  //     }
  //   } else {
  //     next()
  //   }
  // } else {
  //   next()
  // }

  next()
})

router.afterEach(() => {
  setTimeout(() => {
    const height = document.body.scrollHeight;
    window.parent.postMessage(
      { iframeHeight: height },
      'https://digiskillhub.id' 
    );
  }, 300);
});

export default router;
